import React from 'react'

const AboutIconFour = () => {
    return (
        <img src="https://img.icons8.com/?size=100&id=69567&format=png&color=000000" alt="Customized Consulting" style={{ width: '50px', height: '50px' }} />
    )
}

export default AboutIconFour